module.exports = __webpack_public_path__ + "static/media/6.8f29dabc.JPG";